class Vector {
  constructor(coordinates, color, name="") {
    this.x = coordinates[0];
    this.y = coordinates[1];
    this.color = color;
    this.isDragging = false;
    this.isHovered = false;
    this.name = name;
  }

  distance(vector) {
    return Math.hypot(this.x - vector.x, this.y - vector.y);
  }

  plus(vector, color = this.color) {
    return new Vector([this.x + vector.x, this.y + vector.y], color);
  }

  scale(scalar, color = this.color) {
    return new Vector([scalar * this.x, scalar * this.y], color);
  }

  normalize() {
    const length = Math.sqrt(this.x * this.x + this.y * this.y);
    this.x /= length;
    this.y /= length;
  }
}

export default Vector;